<ng-container *transloco="let t">
    @let required = required$ | async;
    <ng-container *ngIf="ngControl.control; let control">
        <ng-container *ngIf="{ value: value.$ | async } as data">
            <!-- <div *ngIf="titleKey">{{ t(titleKey, titleParams) }}</div> -->
            <div class="bazis-switcher">
                <bazis-toggle
                    [color]="color"
                    [disabled]="disabled()"
                    [checked]="data.value"
                    (click)="toggleValue()"
                ></bazis-toggle>
                <span class="bazis-switcher__label">
                    @if (switchData[+data.value].name) {
                        {{ switchData[+data.value].name }}
                    } @else {
                        {{ t(titleKey, titleParams) }}
                    }
                </span>
                @if (tooltipKey) {
                    <bazis-interrogation
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="tooltipSettings?.offset || [-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                        [tooltipIsStatic]="tooltipSettings.isStatic"
                    ></bazis-interrogation>
                }
            </div>
        </ng-container>
    </ng-container>
</ng-container>
